import Model from './model'

export default class TaxonomyOption extends Model {
    /**
     *
     * @returns {number}
     */
    static get transmission_other() {
        return 181;
    }

    /**
     *
     * @returns {number}
     */
    static get fuel_type_unknown() {
        return 178;
    }

    /**
     *
     * @returns {number}
     */
    static get number_of_doors_4plus() {
        return 189;
    }

    /**
     *
     * @returns {number}
     */
    static get number_of_doors_unknown() {
        return 190;
    }

    /**
     *
     * @returns {number}
     */
    static get drive_unknown() {
        return 186;
    }
}
